import { FunctionComponent, forwardRef, PropsWithoutRef, Ref } from 'react';

import { AvatarProps, ForwardProps } from '@pega/cosmos-react-core';

import Message from './Message';
import React from 'react';

export interface TypeIndicatorProps {
  /** ref to the element */
  ref?: Ref<HTMLDivElement>;
  /** Avatar information, can be image and name */
  avatarInfo: Pick<AvatarProps, 'name' | 'imageSrc'>;
  /** Type ahead message */
  message?: string;
}

const TypeIndicator: FunctionComponent<TypeIndicatorProps & ForwardProps> = forwardRef(
  (props: PropsWithoutRef<TypeIndicatorProps>, ref: TypeIndicatorProps['ref']) => {
    const { avatarInfo, message, ...restProps } = props;
    return (
      <Message
        variant="receiver"
        direction="in"
        avatarInfo={avatarInfo}
        typing
        ref={ref}
        message={message}
        {...restProps}
      />
    );
  },
);

export default TypeIndicator;
